// extracted by mini-css-extract-plugin
export default {"PreloadPage_content":"PreloadPage_PreloadPage_content__UJ7oy","PreloaderPage_lottie":"PreloadPage_PreloaderPage_lottie__RtBIF"};